/**
 * @desc Converts a date from the database format to the correct Japanese date format as shown on MARC.
 * I designed this function to be used as a plugin for easy integration throughout the project.
 *
 * @param {string} inputDate - Date in the database format.
 * @returns {string} - Date in the Japanese format.
 */
export function japaneseDateFormat(inputDate) {
  const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土']

  const date = new Date(inputDate)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const dayOfWeek = daysOfWeek[date.getDay()]

  return `${year}年${month}月${day}日(${dayOfWeek})`
}
